import { jrniAPI } from '../../api/jrniAPI';
export var createJrniClient = function (storeId, basketToken, payload) {
    jrniAPI.defaults.headers['Auth-Token'] = basketToken;
    return jrniAPI.post("/".concat(storeId, "/client"), payload);
};
export var checkoutJrniBasket = function (clientId, basketToken, basketId) {
    jrniAPI.defaults.headers['Auth-Token'] = basketToken;
    return jrniAPI.post("/baskets/".concat(basketId, "/checkout"), {
        client: {
            id: clientId,
        },
    });
};
